export interface Product {
  id: string;
  descricao: string;
  tipoProduto: number;
  contemMidia: boolean;
}

export interface ScheduleDataProps {
  pedido: string;
  idGar: string;
  posto: number | null;
  status?: number | null;
  tipo?: number | null;
  pedidoEcommerce: string;
  data: string;
  hora: string;
  detalhePosto: {
    codigo: number | null;
    nomeFantasia: string;
    telefone: number | null;
    endereco: string;
    numero: number | null;
    complemento: string;
    cidade: string;
    uf: string;
    cep: number | null;
    bairro: string;
    videoconferencia: boolean;
  };
}

export interface Order {
  length: number;
  data: string | number | Date;
  historicoPessoaFisica: PessoaFisicaProps;
  historicoPessoaJuridica: PessoaJuridicaProps;
  id: string;
  cpf: string;
  cnpj: string;
  produto: Product;
  name: string;
  email: string;
  pedidoEcommerce: string;
}

export interface ArProps {
  codigo: number;
  nomeFantasia: string;
  telefone: number;
  endereco: string;
  numero: number;
  complemento: string;
  cidade: string;
  uf: string;
  cep: number;
  latitude: number;
  longitude: number;
  bairro: string;
  videoconferencia: string | boolean | null;
  max_distance: number;
  distance: number | null;
}

export interface CardProps {
  icon?: string;
  title?: string;
  textTop?: string;
  textBottom?: string;
  textInfo?: string;
  buttonText?: string;
  onClick?: () => void;
}

export interface ScheduleDetails {
  data: string;
  dataAgendamento: string;
  codigo: number;
  hora: string;
  horaInicialAgendamento: string;
  nomeFantasia: string;
  nomePosto: string;
  pedido: number;
  status: number;
  tipo: number;
  posto: number;
  pedidoEcommerce: string;
  detalhePosto: DetailsLocale;
  bairro: string;
  cidade: string;
  estado: string;
  telefone: string;
  endereco: string;
  numero: string;
}

export interface DetailsProps {
  bairro: string;
  cidade: string;
  dataAgendamento: string;
  endereco: string;
  estado: string;
  horaInicialAgendamento: string;
  numero: string;
  nomePosto: string;
  tipo: {
    descricao: string;
  };
}

interface DetailsLocale {
  data: string | number | Date;
  dataAgendamento: string | number | Date;
  codigo: number;
  nomeFantasia: string;
  telefone: string;
  endereco: string;
  numero: string;
  complemento: string | null;
  cidade: string;
  uf: string;
  cep: string;
  bairro: string;
  videoconferencia: string;
}

interface PessoaFisicaProps {
  pedido: number;
  cpf: string;
  nomeCliente: string;
  email: string;
  endereco: string;
  complemento: string;
  bairro: string;
  municipio: string;
  uf: string;
  pais: string;
  cep: number;
  telefone: string;
  dataNascimento: string;
  pis: number;
  rg: string;
  orgaoEmissor: string;
  ufRG: string;
  tituloEleitor: number;
  zonaEleitoral: number;
  secao: number;
  municipioEleitoral: string;
  ufTituloEleitor: string;
  profissao: string;
  nomePai: string;
  nomeMae: string;
  dataEmissaoRG: string;
  inss: string;
  incapaz: boolean;
  temRepresentante: boolean;
  nomeSocial: string;
  cnh: string;
}

interface PessoaJuridicaProps {
  cnpj: string;
  razaoSocial: string;
  codigoInscricao: number;
  tipoInscricao: string;
  endereco: string;
  complemento: string;
  bairro: string;
  municipio: string;
  uf: string;
  pais: string;
  cep: string;
  telefone: string;
  codigoAtividade: string;
  naturezaAtividade: string;
  nomeFantasia: string;
  dataAbertura: string;
  cadastroIss: number;
  cargo: string;
  idRegTrib: string;
}

export enum ScheduleType {
  DateHour = 'dateHour',
  Location = 'location',
}

export enum Period {
  Morning = 'Manhã',
  Afternoon = 'Tarde',
  Evening = 'Noite',
}

export type DayOfWeekType = {
  diaSemana: string;
  data: string;
  mes: string;
  disabled?: boolean;
};
